<template>
  <OldShopOA />
</template>
<script>
import OldShopOA from "@/components/OldShopOA.vue";
export default {
  components: {
    OldShopOA
  }
}
</script>